'use client';
import { DpRichContentWrapper } from '@/styles/product';
import { memo } from 'react';
import ShadowDomRichText from '@/intl-jdi-common-ssr/components/shadowDomRichText';
export default memo(function RichComponent({
  data,
  className,
  style,
  isShadowDom = true,
}: {
  data: string;
  className?: string;
  style?: React.CSSProperties;
  isShadowDom?: boolean;
}) {
  return (
    <ShadowDomRichText
      richText={data}
      className={className}
      style={style}
      isShadowDom={isShadowDom}
    />
  );
});
